import React from "react";

import Button from "./Button";
import { BUTTON_STYLES } from "./presets";

const VARIANT_STYLES = {
    secondary: BUTTON_STYLES.iconSecondary,
    surface: BUTTON_STYLES.iconSurface,
    ghost: BUTTON_STYLES.iconGhost,
    subtleGhost: BUTTON_STYLES.iconSubtleGhost,
    plain: BUTTON_STYLES.iconPlain,
};

const ToggleIconButton = React.forwardRef(function ToggleIconButton(props, ref) {
    const {
        active = false,
        variant = "secondary",
        activeBgColor = "var(--color-White)",
        activeHoverBgColor = "var(--color-White)",
        activeBorderColor = "var(--color-Button2)",
        inactiveBorderColor = "transparent",
        borderWidth = "1.5px",
        borderRadius = "4px",
        renderIcon,
        activeIcon,
        inactiveIcon,
        children,
        ...buttonProps
    } = props;

    const baseStyle = VARIANT_STYLES[variant] || BUTTON_STYLES.iconSecondary;
    const iconNode =
        typeof renderIcon === "function"
            ? renderIcon(active)
            : active
              ? activeIcon || children
              : inactiveIcon || children;

    return (
        <Button
            {...baseStyle}
            {...buttonProps}
            ref={ref}
            bgColor={active ? activeBgColor : baseStyle.bgColor}
            hoverBgColor={active ? activeHoverBgColor : baseStyle.hoverBgColor}
            border={`${borderWidth} solid ${active ? activeBorderColor : inactiveBorderColor}`}
            borderRadius={borderRadius}
        >
            {iconNode}
        </Button>
    );
});

export default ToggleIconButton;
